import {PolIcon} from "components/PolIcon/policon";
import React, {useEffect} from 'react';
import {Link, useHistory} from "react-router-dom";
import ReactTooltip from "react-tooltip";
import {PRODUCT_ITEM} from "v4/data/apiRoutes";
import {PRODUCT} from "v4/data/entities";
import useFetch from "v4/hooks/useFetch";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import {generateUrl} from "v4/services/api.service";
import GenericVoter from "v4/voters/genericVoter";
import TableLink from "v4/components/utils/TableLink/TableLink";

export default function ProductsListingRowActions({rowId}) {
    const {t} = usePolTranslation();
    const {replace} = useHistory();
    const [{isFinished}, fetchDelete] = useFetch();


    const handleDelete = () => {
        const isConfirmed = window.confirm(t('confirm_delete'));
        if (isConfirmed) {
            fetchDelete({
                url: generateUrl(PRODUCT_ITEM, {id: rowId}),
                config: {
                    method: 'DELETE'
                }
            });
        }
    }

    useEffect(() => {
        if (isFinished) {
            replace({
                state: {hasToRefresh: true}
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFinished]);


    return (
        <>
            <TableLink href={({pathname}) => `${pathname}/${rowId}/edit`}/>
            <ul className="table-actions">
                {GenericVoter(PRODUCT, 'canEdit') &&
                    <li data-for="row-action" data-tip={t('edit')}>
                        <Link to={({pathname}) => `${pathname}/${rowId}/edit`}>
                            <PolIcon icon='edit'/>
                        </Link>
                    </li>
                }

                {GenericVoter(PRODUCT, 'canDelete') &&
                    <li onClick={handleDelete} data-for="row-action" data-tip={t('delete')}>
                        <PolIcon icon='trash'/>
                    </li>
                }
            </ul>
            <ReactTooltip id="row-action" effect="solid"/>
        </>
    )
}
